import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";

import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
    PageWrapper,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { FilterBtn } from '../../../styles/results'
import {
    MdFilterList
} from "react-icons/md";
import { ResultsList } from '../../../components/results-list'

import { CustomModal } from '../../../components/modal'
import { useState } from 'react'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { SelectInput } from "../../../components/select/select";

const schema = yup.object().shape({
    class: yup.string().required("Class is a required field"),
    term: yup.string().required("Term is a required field"),
    subject: yup.string().required("Subject is a required field"),
});

const TeacherResults = () => {
    const [showModal, setShowModal] = useState(false);

    const classOptions = [
        {
            value: "jss1",
            label: "JSS 1",
        },
        {
            value: "jss2",
            label: "JSS 2",
        },
    ];
    const termOptions = [
        {
            value: "firstTerm",
            label: "First TERM",
        },
        {
            value: "secondTerm",
            label: "Second Term",
        },
    ];
    const subjectOptions = [
        {
            value: "english",
            label: "English Language",
        },
        {
            value: "mathematics",
            label: "Mathematics",
        },
    ];

    const {
        handleSubmit,
        register,
        control,
        formState: { errors },
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
        setShowModal(false)
    }
    return (
        <>
            <CustomModal title="Filter" onClose={() => setShowModal(false)} showModal={showModal}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <InputWrapper>
                        <Controller
                            control={control}
                            name="class"
                            render={({ field: { onChange } }) => (
                                <>
                                    <SelectInput
                                        id="class"
                                        type="text"
                                        placeholder="Select Class"
                                        onChange={(val) => onChange(val.value)}
                                        error={errors.class?.message}
                                        options={classOptions}
                                    />
                                </>
                            )}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Controller
                            control={control}
                            name="term"
                            render={({ field: { onChange } }) => (
                                <>
                                    <SelectInput
                                        id="term"
                                        type="text"
                                        placeholder="Select Term"
                                        onChange={(val) => onChange(val.value)}
                                        error={errors.term?.message}
                                        options={termOptions}
                                    />
                                </>
                            )}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Controller
                            control={control}
                            name="subject"
                            render={({ field: { onChange } }) => (
                                <>
                                    <SelectInput
                                        id="subject"
                                        type="text"
                                        placeholder="Select Subject"
                                        onChange={(val) => onChange(val.value)}
                                        error={errors.subject?.message}
                                        options={subjectOptions}
                                    />
                                </>
                            )}
                        />
                    </InputWrapper>
                    <Button
                        type="submit"
                        style={{ marginLeft: 'auto', marginTop: '6rem' }}
                        responsive
                    >
                        PROCEED
                    </Button>
                </form>

            </CustomModal>

            <DashboardWrapper>
                <MainContentWrapper fullHeight>
                    <Container>
                        <MainContent>
                            <PageWrapper>
                                <FilterBtn onClick={() => setShowModal(true)}>
                                    <div className="icon-container">
                                        <MdFilterList />
                                    </div>
                                    filters
                                </FilterBtn>
                                <Heading>
                                    Results
                                </Heading>
                                <Breadcrumb
                                    crumbs={['Results']}
                                />
                                <ResultsList />
                            </PageWrapper>
                        </MainContent>
                    </Container>
                </MainContentWrapper>
            </DashboardWrapper>
        </>

    )
}

export default TeacherResults;
